// extracted by mini-css-extract-plugin
export default {"whySection":"WhySection_whySection__7+TeF","content":"WhySection_content__x7PxZ","header":"WhySection_header__hohX3","description":"WhySection_description__b0Mqf"};